<div class="mx-auto text-center">
  <img
    src="assets/images/error/error-401.png"
    alt=""
    class="mt-3 mb-2"
    height="230"
  />

  <h2 class="fw-bold mt-3 text-primary lh-base">Error Unauthorized !</h2>

  <h4 class="fw-medium mt-2 mb-0 text-dark lh-base">
    Access To Allowed Only For Registered User
  </h4>

  <p class="text-muted fs-15 mb-3">
    Sorry, but you are not authorized to view this page.
  </p>

  <a class="btn btn-primary mb-3" (click)="goBack()"  >Back To page <i class="ti ti-home ms-1"></i ></a>
</div>
